export const verifyDueDate = (date: string): any => {
  const passDueDay = new Date(date).getUTCDate();
  const passDueMonth = new Date(date).getUTCMonth() + 1;
  const passDueYear = new Date(date).getUTCFullYear();

  const today = new Date();

  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const day = today.getDate();

  return {
    expired: day - passDueDay > -8 && month - passDueMonth == 0 && year - passDueYear == 0,
    expire_in: (day - passDueDay + "").replace("-", ""),
  };
};

export const formatDateTime = (date: any) => {
  if (date) {
    const newDate = new Date(date);
    let day: any = newDate.getDate();
    let month: any = newDate.getMonth() + 1;
    const year: any = newDate.getFullYear();
    let hours: any = newDate.getHours();
    let minutes: any = newDate.getMinutes();

    if (day < 10) day = "0" + day;
    if (month < 10) month = "0" + month;
    if (hours < 10) hours = "0" + hours;
    if (minutes < 10) minutes = "0" + minutes;

    return day + "/" + month + "/" + year + " " + hours + ":" + minutes;
  }
  return "-- vazio --";
};

export const formatDateTimeUTC = (date: any) => {
  if (date) {
    const newDate = new Date(date);
    let day: any = newDate.getUTCDate();
    let month: any = newDate.getUTCMonth() + 1;
    const year: any = newDate.getUTCFullYear();
    let hours: any = newDate.getUTCHours();
    let minutes: any = newDate.getUTCMinutes();

    if (day < 10) day = "0" + day;
    if (month < 10) month = "0" + month;
    if (hours < 10) hours = "0" + hours;
    if (minutes < 10) minutes = "0" + minutes;

    return day + "/" + month + "/" + year + " " + hours + ":" + minutes;
  }
  return "-- vazio --";
};